@if (showPrivacyPolicyDialog() && isCollapsed() === false) {
  <a class="text-white no-text-decoration" href="https://hypecast.one/privacy/" target="_blank">Privacy Policy</a>
}
@if (showPrivacyPolicyDialog() && isCollapsed() === true) {
  <a
    class="privacy-policy-icon text-white no-text-decoration"
    href="https://hypecast.one/privacy/"
    target="_blank"
    aria-label="Privacy Policy"
    title="Privacy Policy"
  >
    <mat-icon svgIcon="security" />
  </a>
}
<div
  class="flex flex-row items-center gap-2 mt-4 whitespace-nowrap overflow-hidden"
  [class.actions-brand--collapsed]="isCollapsed()"
>
  @if (isCollapsed() === false) {
    <div class="flex-initial shrink-0">
      <div class="text-white text-base leading-none">Powered by</div>
    </div>
  }

  <div class="flex-initial min-w-0 shrink-0">
    <img
      alt="HYPECAST"
      class="h-auto w-auto object-contain"
      [style.max-height]="isCollapsed() ? '1.25rem' : '1.6rem'"
      [style.max-width]="isCollapsed() ? '3.5rem' : '7rem'"
      src="/assets/logos/HYPECASTwhite.svg"
    />
  </div>
</div>
